'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/CatalogueResultItemAlert.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CatalogueResultItemAlert = function (_BcReactComponent) {
  _inherits(CatalogueResultItemAlert, _BcReactComponent);

  function CatalogueResultItemAlert() {
    _classCallCheck(this, CatalogueResultItemAlert);

    return _possibleConstructorReturn(this, (CatalogueResultItemAlert.__proto__ || Object.getPrototypeOf(CatalogueResultItemAlert)).apply(this, arguments));
  }

  _createClass(CatalogueResultItemAlert, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isFocusOnUpdate) {
        if (this._itemAddedMessage) {
          this._itemAddedMessage.focus();
        }
      }
      return null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isFocusOnUpdate) {
        if (this._itemAddedMessage) {
          this._itemAddedMessage.focus();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var label = this.props.label;


      return _react2.default.createElement(
        'span',
        { className: 'cp-catalogue-result-item-alert', tabIndex: '-1', ref: function ref(el) {
            return _this2._itemAddedMessage = el;
          } },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          label
        ),
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          _react2.default.createElement(
            _baseAlerts.AlertSuccess,
            null,
            label
          )
        )
      );
    }
  }]);

  return CatalogueResultItemAlert;
}(_baseBcReactComponent2.default);

CatalogueResultItemAlert.propTypes = {
  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  isFocusOnUpdate: _react.PropTypes.bool
};

exports.default = CatalogueResultItemAlert;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-result-item-alert/components/CatalogueResultItemAlert.component.js
// module id = 975
// module chunks = 1